const MapStyles = [
  // { elementType: 'geometry', stylers: [{ color: '#F6F3EF' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#FFFFFF' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#545454' }] },

  // { featureType: 'administrative', stylers: [{  color: '#A3CCFF'  }] },

  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#9C9C9C' }],
  },

  // { featureType: 'administrative.land_parcel', stylers: [{  color: '#A3CCFF'  }] },
  // { featureType: 'administrative.locality', stylers: [{  color: '#A3CCFF'  }] },
  // { featureType: 'administrative.neighborhood', stylers: [{  color: '#A3CCFF'  }] },

  {
    featureType: 'administrative.province',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#BCBFCD' }],
  },
  //
  // { featureType: 'landscape', stylers: [{  color: '#A3CCFF'  }] },
  // { featureType: 'landscape.man_made', stylers: [{  color: '#A3CCFF'  }] },
  { featureType: 'landscape.man_made', stylers: [{ color: '#E9E6E3' }] },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry.fill',
    stylers: [{ visibility: 'on' }],
  },
  // { featureType: 'landscape.natural.landcover', stylers: [{  color: '#A6F2B3'  }] },
  // { featureType: 'landscape.natural.terrain', stylers: [{  color: '#EDEDCF'  }] },
  // { featureType: 'landscape.province', stylers: [{  color: '#A3CCFF'  }] },
  //
  // { featureType: 'poi', stylers: [{  color: '#A3CCFF'  }] },
  {
    featureType: 'poi.attraction',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'poi.attraction',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#664F3D' }],
  },

  {
    featureType: 'poi.business',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'poi.business',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#664F3D' }],
  },

  {
    featureType: 'poi.government',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'poi.government',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#664F3D' }],
  },

  {
    featureType: 'poi.medical',
    elementType: 'geometry.fill',
    stylers: [{ color: '#EAE1E1' }],
  },
  {
    featureType: 'poi.medical',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'poi.medical',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#664F3D' }],
  },

  { featureType: 'poi.park', stylers: [{ color: '#CAE5C2' }] },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#226600' }],
  },

  {
    featureType: 'poi.place_of_worship',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'poi.place_of_worship',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#664F3D' }],
  },

  { featureType: 'poi.school', stylers: [{ color: '#E5E3DC' }] },
  {
    featureType: 'poi.school',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'poi.school',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#664F3D' }],
  },

  {
    featureType: 'poi.sports_complex',
    elementType: 'geometry',
    stylers: [{ color: '#E2EFDE' }],
  },
  {
    featureType: 'poi.sports_complex',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'poi.sports_complex',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#664F3D' }],
  },

  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{ color: '#ffe180' }],
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry.fill',
    stylers: [{ color: '#FF8400' }],
  },
  //
  // { featureType: 'transit', stylers: [{  color: '#A3CCFF'  }] },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{ color: '#B6B8C3' }],
  },

  // { featureType: 'transit.station', stylers: [{  color: '#A3CCFF'  }] },

  {
    featureType: 'transit.station.airport',
    elementType: 'geometry.fill',
    stylers: [{ color: '#DBDEEB' }],
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#FFFFFF' }],
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#3A4CA6' }],
  },

  // { featureType: 'transit.station.bus', stylers: [{  color: '#A3CCFF'  }] },
  // { featureType: 'transit.station.rail', stylers: [{  color: '#D2D5E4'  }] },

  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [{ color: '#A3CCFF' }],
  },
];

export default MapStyles;

// featureType:
// administrative
//   administrative.country
//   administrative.land_parcel
//   administrative.locality
//   administrative.neighborhood
//   administrative.province
// landscape
//   landscape.man_made
//   landscape.natural
//   landscape.natural.landcover
//   landscape.natural.terrain
// poi
//   poi.attraction
//   poi.business
//   poi.government
//   poi.medical
//   poi.park
//   poi.place_of_worship
//   poi.school
//   poi.sports_complex
// road
//   road.arterial
//   road.highway
//   road.highway.controlled_access
//   road.local
// transit
//   transit.line
//   transit.station
//   transit.station.airport
//   transit.station.bus
//   transit.station.rail
// water
//
// elementType:
// all
// geometry
//   geometry.fill
//   geometry.stroke
// labels
//   labels.icon
//   labels.text
//   labels.text.fill
//   labels.text.stroke
//
// stylers:
// hue (an RGB hex string of format #RRGGBB)
// lightness (a floating point value between -100 and 100)
// gamma (a floating point value between 0.01 and 10.0, where 1.0 applies no correction)
// invert_lightness (if true)
// visibility (on, off, or simplified)
// color (an RGB hex string of format #RRGGBB)
// weight (an integer value, greater than or equal to zero)
